module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('changepassform', {
    on: {
      "success": _vm.onSuccess
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba08ad26","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = 736
// module chunks = 16